<app-banner></app-banner>

<div class="container-fluid innerPageMenu">
  <div class="row">
      <div class="col-md-3">
          <nav id="secondary-navigation">
              <!-- Header -->
              <header class="header">
                  <h5>Beyond Education</h5>
              </header>
              <!-- /Header -->
              <ul>
                  <li routerLinkActive="active">
                      <a routerLink="/beyond/academic" >Academics</a>
                  </li>
                  <li routerLinkActive="active">
                    <a routerLink="/beyond/examination" >Examination</a>
                </li>
                <li routerLinkActive="active">
                  <a routerLink="/beyond/competition" >IH Competitions</a>
              </li>
                  <li routerLinkActive="active">
                      <a routerLink="/beyond/celebration" >Celebrations</a>
                  </li>
                  <li routerLinkActive="active">
                      <a routerLink="/beyond/workshop" >Workshops</a>
                  </li>

                  <li routerLinkActive="active">
                    <a routerLink="/beyond/ptm" >PTMs</a>
                </li>
                <li routerLinkActive="active">
                  <a routerLink="/beyond/trip" >Excursions and Trips</a>
              </li>
              <li routerLinkActive="active">
                <a routerLink="/beyond/clubs" >Clubs</a>
            </li>
            <li routerLinkActive="active">
              <a routerLink="/beyond/council" >Student’s Council</a>
          </li>
          
                  
              </ul>
          </nav>
      </div>
      <div class="col-md-9">
          <router-outlet></router-outlet>
      </div>
  </div>
</div>